import React, { useState, useRef } from 'react'
import './landing.css';
import Header from '../Header/Header';
import AboutUs from './AboutUs';
import Advantages from './Advantages';
import Services from './Services';
import Location from './Location';
import Footer from '../Footer/Footer';

const Landing = () => {
    const [language, setLanguage] = useState('deutsch');
    const changeLanguage = (option) =>{
        setLanguage(option)
    }

    const aboutRef = useRef(null);
    const servicesRef = useRef(null);
    const contactRef = useRef(null);

    const scrollTo = (element, duration) => {
        const startPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; // Get the current scroll position

        const targetPosition = element.offsetTop; // Get the target position of the element

        const distance = targetPosition - startPosition; // Calculate the distance to scroll
        const startTime = performance.now(); // Get the current time

        const easeInOutQuad = t => t<.5 ? 2*t*t : -1+(4-2*t)*t; // Easing function (you can use other easing functions)

        const animateScroll = currentTime => {
            const elapsedTime = currentTime - startTime; // Calculate elapsed time
            const scrollProgress = easeInOutQuad(elapsedTime / duration); // Calculate progress with easing
            window.scrollTo(0, startPosition + distance * scrollProgress); // Scroll to the new position

            if (elapsedTime < duration) {
                requestAnimationFrame(animateScroll); // Continue the animation until duration is reached
            }
        };

        requestAnimationFrame(animateScroll); // Start the animation
    };

    return (
        <>
            <Header language={language} changeLanguage={changeLanguage} scrollToAbout={() => scrollTo(aboutRef.current, 1000)} scrollToServices={() => scrollTo(servicesRef.current, 1000)} scrollToContact={() => scrollTo(contactRef.current, 1000)}/>
            <section className='hero_section_container'>
                <div className='hero_content'>
                    <h1 className='hero_title'>{language === 'deutsch' ? 'Kurse für Bau- und Lagermaschinen' : 'COURSES FOR CONSTRUCTION AND WAREHOUSE MACHINES'}</h1>
                    <p className='subtitle'>{language === 'deutsch' ? 'Deutsches Ausbildungszentrum' : 'German training center'}</p>
                    <div className='hero_btn' onClick={() => scrollTo(aboutRef.current, 1000)}><p className='hero_btn_text'>{language === 'deutsch' ? 'Finde mehr heraus' : 'Find out more'}</p></div>
                </div>
            </section>
            <AboutUs language={language} reference={aboutRef}/>
            <Advantages language={language}/>
            <Services language={language} reference={servicesRef}/>
            <Location language={language} reference={contactRef}/>
            <Footer language={language} scrollToAbout={() => scrollTo(aboutRef.current, 1000)} scrollToServices={() => scrollTo(servicesRef.current, 1000)} scrollToContact={() => scrollTo(contactRef.current, 1000)}/>
        </>
    )
}

export default Landing